// @flow

import { AppListingTab, AppListingTabs } from '@atlassian/mpac-app-listing';
import { useParams } from '@atlassian/mpac-ui';
import { stringify } from 'query-string';

import { AllHostingTypeQueryParams } from '../../../../../../../constants';

import type { GetMarketplaceAppByAppKeyQuery } from '../queries.gql.types';
import type { ReturnType } from '@atlassian/mpac-types';
import type { LocationShape } from 'react-router-dom';

type App = $NonMaybeType<$PropertyType<GetMarketplaceAppByAppKeyQuery, 'marketplaceAppByKey'>>;

type GetRouteToRedirectToParams = {
  app: App,
  params: ReturnType<typeof useParams>,
};

export const getRouteToRedirectTo = ({
  app,
  params,
}: GetRouteToRedirectToParams): LocationShape => {
  const pathname = `/apps/${app.appId}/${app.slug}`;
  const search = stringify({
    ...(AllHostingTypeQueryParams.includes(params.hosting) && { hosting: params.hosting }),
    tab: AppListingTabs.includes(params.tab) ? params.tab : AppListingTab.Overview,
  });

  return { pathname, search };
};
